import actions from '../actions';
import { put, takeLatest } from 'redux-saga/effects';
import { getServiceProvider, IAuthService, IServiceProvider } from '../../../services';
import { AsyncError } from "../../../common";

const resetPasswordSaga = takeLatest(actions.resetPassword.request.type, function* () {
  const serviceProvider: IServiceProvider = yield getServiceProvider();
  const authService: IAuthService = yield serviceProvider.getAuthService();

  try {
    yield authService.sendPasswordResetEmail();
    yield put(actions.resetPassword.success());
  } catch (e) {
    yield put(actions.resetPassword.failure(e as AsyncError));
    serviceProvider.analyticsService.logError(e as AsyncError);
  }
});

const sagas = [resetPasswordSaga];

export default sagas;
